export default __webpack_public_path__ + "static/media/banner_plain.54d5d91d.webp";